const disclaimer = [
    {
        key: "disclaimer",
        heading: "DISCLAIMER",
        body: [
            "All the images used in this project are my own. There is an images.txt file in this code's repository which contains details of all the images used.",
            "Custom Css and icons are adapted from www.css.gg under MIT license. Appropriate comments are mentioned in the code's respective css files.",
            "Only the Resume is to be downloaded and distributed with the intent of hiring or review. All the other documents or images are not to be downloaded and distributed. If anyone is interested in getting those documents, please reach out to me privately via email."
        ]
    }
];

export default disclaimer;